import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,

    ACTION_REQUEST,
    ACTION_SUCCESS,
    ACTION_FAILURE

} from '../constants/login';

import { post } from 'common/utils/api';
import { Urls } from 'django_js_control/reverse';
import { parse } from 'query-string';

export function loginUser(data) {

    return (dispatch, getState) => {
        const endpoint = Urls['control:login:api:login']();

        const { router: { location: { search } } } = getState();

        dispatch(post({
            endpoint,
            types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE],
            meta: parse(search),
            data
        }));
    };
}

export function actionUser(data, action) {

    return (dispatch, getState) => {
        const endpoint = Urls['control:login:api:action'](action);

        const { router: { location: { search } } } = getState();

        dispatch(post({
            endpoint,
            types: [ACTION_REQUEST, ACTION_SUCCESS, ACTION_FAILURE],
            meta: {
                ...parse(search),
                email: data.email
            },
            data
        }));
    };
}



// WEBPACK FOOTER //
// ./assets/app/login/actions/login.js